type stateType = { configuratorLoaded: boolean }

export const state = () => ({
  configuratorLoaded: false,
})

export const mutations = {
  setIsConfiguratorLoaded(state: stateType, configuratorLoaded: boolean) {
    state.configuratorLoaded = configuratorLoaded
  },
}

export const getters = {
  isConfiguratorLoaded(state: stateType) {
    return state.configuratorLoaded
  },
}
